export default __webpack_public_path__ + "assets/images/327b535e667899f186d588eac7e6ec29.png";